import { useContext } from "react";

import { FetchOptionsContext } from "./FetchOptionsContext";

/**
 * Hook to access the FetchOptionsContext.
 *
 * @returns {Object} The fetch options context value with default fallbacks
 */
export const useFetchOptions = () => {
  const context = useContext(FetchOptionsContext);

  return context;
};
